// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"8fa6021f","976":"e2fb755a"}[chunkId] + ".chunk.css";
};